import { apiClient } from './client';
import { ContractTemplate, Contract } from '../types/contracts';

export const contractTemplateApi = {
  list: () => apiClient.get<{ data: ContractTemplate[] }>('/api/contract-templates'),
  create: (input: { name: string; category?: string; templateContent: string }) =>
    apiClient.post<{ data: { id: number } }>('/api/contract-templates', input),
  deactivate: (id: number) => apiClient.delete<{ data: { id: number; is_active: boolean } }>(`/api/contract-templates/${id}`),
  update: (id: number, input: { name: string; category?: string; templateContent: string }) => apiClient.put<{ data: { id: number } }>(`/api/contract-templates/${id}`, input),
};

export const contractApi = {
  listForEmployee: (employeeId: number) => apiClient.get<{ data: Contract[] }>(`/api/employees/${employeeId}/contracts`),
  get: (id: number) => apiClient.get<{ data: Contract }>(`/api/contracts/${id}`),
  downloadUrl: (id: number) => `/api/contracts/${id}/download`,
  return: (id: number, comment: string) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/return`, { comment }),
  resubmit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/resubmit`),
  create: (employeeId: number, input: Record<string, unknown>) =>
    apiClient.post<{ data: { id: number; contractReference: string } }>(`/api/employees/${employeeId}/contracts`, input),
  submit: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/submit`),
  requestApproval: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/request-approval`),
  decide: (id: number, input: { decision: 'approved' | 'rejected' }) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/decide`, input),
  sign: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/sign`),
  finalise: (id: number) => apiClient.post<{ data: { status: string } }>(`/api/contracts/${id}/finalise`),
};
